import CoreBase from '../../../../services/engines/CoreBase';
import searchFetcher from './SearchFetcher';

/**
 * Executes search queries via SearchFetcher.
 * Owns loading state and min-length guard.
 * Only SearchEngine should use this directly.
 * Not a singleton — instantiated by SearchEngine (see Development.Patterns, ServiceAgent Pattern).
 */
class SearchExecutor extends CoreBase {
    // Class field — overrides CoreBase._name so logError shows correct source
    _name = 'SearchExecutor';

    _loading = false;

    /** @returns {boolean} True if a search is in progress */
    isLoading = () => this._loading;

    /**
     * Executes a search query. Returns null if query is too short or call fails.
     * @param {string} query - Search term, min 3 chars
     * @param {number} page - Page number
     * @param {number} size - Page size
     * @returns {object|null} { items, total, page } or null
     */
    execute = async (query, page, size) => {
        try {
            if (!query || query.trim().length < 3) return null;
            this._loading = true;
            return await searchFetcher.search(query, page, size);
        } catch (error) {
            this.logError('execute', error.message);
            return null;
        } finally {
            this._loading = false;
        }
    };
}

const searchExecutor = new SearchExecutor();
export default searchExecutor;
